/*@ngInject*/
const UIHideSelectOnScrollDirective = function () {

    let linkFunction = function ($scope, $elm, $attrs, $select) {
        let element = $($elm),
            container = element.closest($attrs.uiHideSelectOnScrollSelector),
            handleScroll = function () {
                if ($select.open) {
                    $select.close();
                }
            };

        container.on('scroll.uiHideSelectOnScroll', handleScroll);

        $('.content').bind("DOMMouseScroll mousewheel onmousewheel", function(event) {
            if ($select.open) {
                $select.close();
            }
        });

        $scope.$on('$destroy', function () {
            container.off('scroll.uiHideSelectOnScroll', handleScroll);
        });

    };

    return {
        require: 'uiSelect',
        restrict: 'A',
        replace: false,
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiHideSelectOnScroll', UIHideSelectOnScrollDirective);
